import React from 'react';
import './cart2.css';
import { useNavigate } from 'react-router-dom';
import img_p1 from '../../images/p1.png';
import img_p2 from '../../images/p2.png';
import img_p3 from '../../images/p3.png';
import img_p4 from '../../images/p4.png';

const packages = [
  {
    id: 'robo-core',
    title: 'ARTHRO3D ROBO Core',
    badge: 'Core Platform',
    badgeBg: '#e0e7ff',
    badgeColor: '#3730a3',
    route: '/package-robo-core',
    bullets: [
      'CT-scan based 3D robotic pre-planning software',
      'Modular, re-usable, patented patient-specific jigs',
      'Open platform for all company implants',
      'Operator-independent & cost-effective workflow'
    ],
    img: img_p1,
    accentBg: '#1e3a8a',
    className: 'techCart1'
  },
  {
    id: 'robo-xr',
    title: 'ARTHRO3D ROBO XR (Single User)',
    badge: 'Mixed Reality',
    badgeBg: '#f3e8ff',
    badgeColor: '#6b21a8',
    route: '/package-robo-xr',
    bullets: [
      'Mixed Reality Platform (Smart Glass wearable device)',
      'Real-time 3D plan overlay directly on native bone',
      'Pre-planning software & patient-specific alignment',
      'Open platform for all company implants',
      'Single-user real-time surgical execution'
    ],
    img: img_p2,
    accentBg: '#3E66DF',
    className: 'techCart2'
  },
  {
    id: 'robo-xr-pro',
    title: 'ARTHRO3D ROBO XR PRO (Multi User)',
    badge: 'Enterprise / Multi-User',
    badgeBg: '#fee2e2',
    badgeColor: '#991b1b',
    route: '/package-robo-xr-pro',
    bullets: [
      'Collaborative Multi-User Mixed Reality platform',
      'Real-time surgical telecast & cloud-based technology',
      'Priority AI pre-planning software',
      'Equipped with 3D trackers, pointers & verification paddles',
      'Enterprise support for hospital departments & teams'
    ],
    img: img_p3,
    accentBg: '#854d0e',
    className: 'techCart3'
  },
  {
    id: 'simulation-lab',
    title: 'ARTHRO3D ROBO SIMULATION LAB',
    badge: 'Academic & Training',
    badgeBg: '#d1fae5',
    badgeColor: '#065f46',
    route: '/package-simulation-lab',
    bullets: [
      'Complete AI & Mixed Reality surgical simulation environment',
      'Hands-on 3D robotic training for medical colleges & fellowships',
      'Comprehensive pre-planning software & case study modules',
      'Risk-free surgical trial execution without operating room risk'
    ],
    img: img_p4,
    accentBg: '#047857',
    className: 'techCart4'
  }
];

const Cart2 = ({ loader }) => {
  const navigate = useNavigate();

  const chengRouts = (route) => {
    if (loader) loader(true);
    setTimeout(() => {
      navigate(route);
    }, 500);
  };

  return (
    <div className="tech-platforms-wrapper">
      <div className="text-center mb-5">
        <p className="display-2 fw-medium text-dark techSectionHeader">Our Technological Platforms</p>
      </div>

      <div className="container card-deck-container">
        <div className="card-deck-js">
          {packages.map((item, index) => (
            <div
              key={item.id}
              className={`card row ${item.className}`}
            >
              {/* Left Content Side */}
              <div
                className="col-md-6 col-12 cardUp p-4"
                style={{ background: '#F5F5F5', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
                onClick={() => chengRouts(item.route)}
              >
                <div className="text-start col-11 m-auto mt-2">
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <span
                      className="badge px-3 py-2 rounded-pill fw-semibold"
                      style={{ background: item.badgeBg, color: item.badgeColor, fontSize: '13px' }}
                    >
                      {item.badge}
                    </span>
                  </div>
                  <p className="fs-2 fw-bold text-dark mb-3">{item.title}</p>
                  <ul className="ps-3 mb-4">
                    {item.bullets.map((bullet, idx) => (
                      <li key={idx} className="mb-2">
                        <span className="fs-6" style={{ color: '#475569' }}>{bullet}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="col-11 m-auto mb-2">
                  <div style={{ height: '50px' }}>
                    <div
                      className="buttonDiv"
                      onClick={(e) => {
                        e.stopPropagation();
                        chengRouts(item.route);
                      }}
                    >
                      <div className="button">Read More</div>
                      <div className="button-clip">Read More</div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="cardDown col-md-6 col-12 d-flex align-items-center justify-content-center p-3 p-md-3"
                style={{ background: item.accentBg }}
                onClick={() => chengRouts(item.route)}
              >
                <div className="img-ratio-box">
                  <img
                    src={item.img}
                    alt={item.title}
                    style={{ background: item.accentBg }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Cart2;